import type { IconData } from '@stacksjs/iconify-core'

export const disableHeartFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M23.487 7.719c-7.475-6.572-19.401-2.552-21.56 7.19C.434 21.257 2.96 26.678 6.683 31.112c3.695 4.4 8.74 8.035 12.714 10.897l.028.02a7.84 7.84 0 0 0 9.148 0l.028-.02c3.973-2.862 9.019-6.497 12.714-10.897c3.724-4.434 6.249-9.855 4.758-16.201c-2.16-9.743-14.086-13.763-21.56-7.191a12 12 0 0 0-.514.48c-.168-.166-.34-.329-.513-.48\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M2.232 2.232a2.5 2.5 0 0 1 3.536 0l40 40a2.5 2.5 0 0 1-3.536 3.536l-40-40a2.5 2.5 0 0 1 0-3.536\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default disableHeartFlat
